import { render, staticRenderFns } from "./SiteSnapshot.vue?vue&type=template&id=2f925f71&scoped=true"
import script from "./SiteSnapshot.vue?vue&type=script&lang=js"
export * from "./SiteSnapshot.vue?vue&type=script&lang=js"
import style0 from "./SiteSnapshot.vue?vue&type=style&index=0&id=2f925f71&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f925f71",
  null
  
)

export default component.exports